module.exports = __webpack_public_path__ + "img/philosophy_training.1f411652.webp";